export default __webpack_public_path__ + "static/media/loupe.95453df8.svg";